import { ElementRef, NgZone } from '@angular/core';
import Sortable from 'sortablejs';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SingleMetricSelectorModalComponent } from 'CalculationsApp/ts/features/metric-selector-modal/components/single-metric-selector-modal/single-metric-selector-modal.component';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import equal from 'Angular/utils/equal/deep-equal';
import { disablePointerEvents, enablePointerEvents } from 'Angular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../metric-selector-modal/components/single-metric-selector-modal/single-metric-selector-modal.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["singleMetricSelectorModal"];
function KeyStatsModalComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "div", 20)(3, "div", 21)(4, "div", 22);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 23)(7, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵlistener("click", function KeyStatsModalComponent_div_22_Template_div_click_9_listener() { const i_r3 = i0.ɵɵrestoreView(_r2).index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.showMetricSelector(i_r3)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 9);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const keyStat_r5 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(keyStat_r5.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", "Reorder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-move");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", "Edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
} }
/**
 * Key Stats Customization Modal Component
 *
 * Required Attributes:
 *  - defaultKeyStats: The default key stats to use when a user wishes to restore the defaults.
 *                    Should be a list of json objects with the following structure:
 *                          {
 *                              calc_name: the internal calc name used to represent this calc
 *                              label: name of the calc to display on the front-end
 *                           }
 *  - keyStats: The user's preferred key stats. Should have the same structure as the defaultKeyStats
 *  - keyStatsPreferenceField: Name of the key stats preference field to save the users key stats to
 *  - metricMenuType: Security type that determines what kind of menu to show to user.
 */
export class KeyStatsModalComponent {
    constructor(accountsService, eltRef, featureService, ngZone) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.featureService = featureService;
        this.ngZone = ngZone;
        this.errorText = '';
        this.initializedSortable = false;
        this.keyStatEditIndex = -1;
        this.modalOpen = false;
        this.defaultOnly = false;
        this.submitButtonText = 'Update';
        this.defaultKeyStats = JSON.parse(eltRef.nativeElement.getAttribute('defaultKeyStats'));
        this.keyStats = JSON.parse(eltRef.nativeElement.getAttribute('keyStats'));
        this.keyStatsPreferenceField = eltRef.nativeElement.getAttribute('keyStatsPreferenceField');
        this.metricMenuType = eltRef.nativeElement.getAttribute('metricMenuType');
        this.defaultOnly = eltRef.nativeElement.getAttribute('defaultOnly') === 'True';
        this.originalKeyStats = JSON.parse(JSON.stringify(this.keyStats));
    }
    ngOnDestroy() {
        if (this.putUserPreferencesSubscription) {
            this.putUserPreferencesSubscription.unsubscribe();
        }
    }
    openModal() {
        if (!this.featureService.userHasFeatures([CUSTOMIZE_PAGES_FEATURE])) {
            this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
            return;
        }
        if (!this.initializedSortable) {
            this.initializeSortable();
        }
        this.modalOpen = true;
    }
    initializeSortable() {
        const keyStatsContainer = document.getElementById('key-stats-list-container');
        const className = 'plate';
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(keyStatsContainer, {
                handle: '.btn-reorder',
                scroll: false,
                animation: 150,
                onUpdate: (evt) => {
                    // The Sortable library is outside our Angular context, so we need to wrap
                    // our handler in a ngZone.run statement so that we are within a digest cycle.
                    this.ngZone.run(() => {
                        this.updateOrdering(evt.oldIndex, evt.newIndex);
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                    disablePointerEvents(document, className);
                },
                onEnd: () => {
                    enablePointerEvents(document, className);
                },
            });
        });
        this.initializedSortable = true;
    }
    updateOrdering(oldIndex, newIndex) {
        this.keyStats.splice(newIndex, 0, this.keyStats.splice(oldIndex, 1)[0]);
    }
    closeModal() {
        this.setError('');
        this.keyStats = JSON.parse(JSON.stringify(this.originalKeyStats));
        this.modalOpen = false;
    }
    setError(errorText) {
        this.errorText = errorText;
    }
    submit() {
        const keyStatCalcs = this.keyStats.map((keyStat) => keyStat.calc_name);
        const originalKeyStatCalcs = this.originalKeyStats.map((keyStat) => keyStat.calc_name);
        if (equal(keyStatCalcs, originalKeyStatCalcs)) {
            this.closeModal();
            return;
        }
        this.putUserKeyStats();
    }
    putUserKeyStats() {
        const keyStatCalcs = this.keyStats.map((keyStat) => keyStat.calc_name);
        this.putUserPreferencesSubscription = this.accountsService
            .putUserPreferences({ [this.keyStatsPreferenceField]: keyStatCalcs })
            .subscribe({
            next: () => {
                window.location.reload();
            },
            error: () => {
                this.setError('Problem updating Key Stats');
            },
        });
    }
    restoreDefaults() {
        this.keyStats = JSON.parse(JSON.stringify(this.defaultKeyStats));
        this.setError('');
    }
    showMetricSelector(index) {
        this.keyStatEditIndex = index;
        setTimeout(() => {
            this.singleMetricSelectorModal.openModal();
        });
    }
    selectMetric(metric) {
        if (metric === undefined) {
            return;
        }
        const newKeyStatCalc = 'id' in metric // Is instance of AutocompleteResult
            ? { calc_name: metric.id, label: metric.name }
            : { calc_name: metric.internal_name, label: metric.label };
        const existingIndex = this.keyStats.findIndex((keyStat) => keyStat.calc_name === newKeyStatCalc.calc_name);
        // key stat calc was already in user's chosen key stats
        if (existingIndex !== -1) {
            this.setError(`${newKeyStatCalc.label} is already a Key Stat.`);
            return;
        }
        this.keyStats.splice(this.keyStatEditIndex, 1, newKeyStatCalc);
        this.setError('');
    }
}
KeyStatsModalComponent.ɵfac = function KeyStatsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || KeyStatsModalComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i0.NgZone)); };
KeyStatsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: KeyStatsModalComponent, selectors: [["ycn-key-stats-modal"]], viewQuery: function KeyStatsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleMetricSelectorModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, standalone: false, decls: 28, vars: 9, consts: [["singleMetricSelectorModal", ""], ["data-test-id", "key-stats-customize-button", 1, "btn", "btn-secondary", 3, "click"], [3, "closeModalHandler", "open", "requiresAction"], [1, "modal-header"], [1, "modal-title"], [1, "modal-header-actions"], [1, "modal-header-action"], [1, "btn", "btn-modal-header", 3, "click"], [1, "btn", "btn-modal-header", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "divider-horizontal"], ["id", "key-stats-list-container", 1, "plates", "plates-view-cols"], ["class", "plate-container", "data-test-id", "key-stats-stat", 4, "ngFor", "ngForOf"], [3, "cancelHandler", "submitHandler", "errorText", "submitButtonText"], [3, "submitModalHandler", "submitModalAutocompleteHandler", "selectedMetricName", "searchType", "defaultOnly"], ["data-test-id", "key-stats-stat", 1, "plate-container"], [1, "plate", "plate-purple"], [1, "plate-header"], [1, "plate-title"], [1, "plate-title-name"], [1, "plate-controls"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-reorder", 3, "tooltipPlacement", "tooltipTitle"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click", "tooltipPlacement", "tooltipTitle"]], template: function KeyStatsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵlistener("click", function KeyStatsModalComponent_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openModal()); });
        i0.ɵɵtext(1, "Customize");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function KeyStatsModalComponent_Template_ycn_modal_base_closeModalHandler_2_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
        i0.ɵɵtext(5, "Customize Key Stats");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "div", 7);
        i0.ɵɵlistener("click", function KeyStatsModalComponent_Template_div_click_8_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.restoreDefaults()); });
        i0.ɵɵelementStart(9, "span");
        i0.ɵɵtext(10, "Restore Defaults");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "div", 6)(12, "div", 8);
        i0.ɵɵlistener("click", function KeyStatsModalComponent_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(13, "svg", 9);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(14, "div", 10)(15, "div", 11)(16, "div", 12)(17, "p");
        i0.ɵɵtext(18, " Edit or Reorder your Key Stats");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 12)(21, "div", 14);
        i0.ɵɵtemplate(22, KeyStatsModalComponent_div_22_Template, 11, 7, "div", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(23, "div", 13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(24, "ycn-simple-modal-footer", 16);
        i0.ɵɵlistener("cancelHandler", function KeyStatsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_24_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); })("submitHandler", function KeyStatsModalComponent_Template_ycn_simple_modal_footer_submitHandler_24_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(25, "ycn-feature-needed");
        i0.ɵɵelementStart(26, "ycn-single-metric-selector-modal", 17, 0);
        i0.ɵɵlistener("submitModalHandler", function KeyStatsModalComponent_Template_ycn_single_metric_selector_modal_submitModalHandler_26_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectMetric($event)); })("submitModalAutocompleteHandler", function KeyStatsModalComponent_Template_ycn_single_metric_selector_modal_submitModalAutocompleteHandler_26_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectMetric($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("open", ctx.modalOpen)("requiresAction", true);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngForOf", ctx.keyStats);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("errorText", ctx.errorText)("submitButtonText", ctx.submitButtonText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedMetricName", ctx.keyStats[ctx.keyStatEditIndex] == null ? null : ctx.keyStats[ctx.keyStatEditIndex].calc_name)("searchType", ctx.metricMenuType + "_calc")("defaultOnly", ctx.defaultOnly);
    } }, dependencies: [i3.NgForOf, i4.FeatureNeededComponent, i5.IconDirective, i6.SingleMetricSelectorModalComponent, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.TooltipDirective], encapsulation: 2 });
